/*
 * File: UIProgress.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Presents a loading indicator either as a block element or as a full screen popup.
 */
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Modal from "@material-ui/core/Modal";

const styles = theme => ({
  progress: {
    margin: "0 auto",
    marginTop: theme.spacing(2.5),
    display: "block"
  },
  progressContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    background: "rgba(0, 0, 0, 0)"
  }
});

const UIProgress = ({ classes, fullScreen = false }) => {
  const progress = <CircularProgress className={classes.progress} size={60} />;
  if (fullScreen) {
    return (
      <Modal open>
        <div className={classes.progressContainer}>{progress}</div>
      </Modal>
    );
  } else {
    return progress;
  }
};

UIProgress.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool
};

export default withStyles(styles)(UIProgress);
